import { resourceService } from "@libs/axios"
import { fetchDashboardSubmoduleStudentStatus, teacherDashboardClassChange, fetchTeacherDashboardOverview, teacherDashboardModuleChange } from "@store/actions/teacherDashboardActions"
import { takeLatest, put } from "redux-saga/effects"
import { call } from "redux-saga/effects"
import { ResponseType } from "@store/index"
import { fetchTeacherDashboardOverview as fetchingTeacherDashboardOverview } from "@store/actions/teacherDashboardActions"
import { setTeacherDashboardOverview, setLoading,setDashboardSubmoduleStudentStatus, setModuleOptions, setAssignmentOptions, setModuleFilter, setAssignmentFilter } from "@store/reducers/teacherDashboardReducer"
const API_URL = process.env.REACT_APP_API_URL;

function* fetchTeacherDashboardOverviewSaga(action: ReturnType<typeof fetchingTeacherDashboardOverview>) {
  yield put(setLoading(true))
  try {
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/dashboard_teacher_overview/`)
      if (response?.data) {
        yield put(setTeacherDashboardOverview(response.data))
      }
    } catch (error) {
      console.log(error)
    } finally {
      yield put(setLoading(false))
    }
  }
  function* fetchDashboardSubmoduleStudentStatusSaga(action: ReturnType<typeof fetchDashboardSubmoduleStudentStatus>) {
    try {
      const payload = action.payload || {} as any;
      console.log("payload",payload)
      
      if (payload.export_data === true) {
        yield put(setLoading(true));
        //@ts-ignore
        const dataUrl = yield call(resourceService.get, API_URL + `/api/dashboard_submodule_student_status/`, {
          params: { ...payload, export_data: true },
        });

        if (dataUrl.status === 200 && dataUrl.data?.file_url) {
          const anchor = document.createElement('a');
          anchor.href = dataUrl.data.file_url;
          anchor.download = 'report.xlsx';
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
        }
        yield put(setLoading(false));
        return;
      }

      yield put(setLoading(true));
      const response: ResponseType = yield call(resourceService.get, API_URL + `/api/dashboard_submodule_student_status/`, {
        params: payload
      });
      if (response?.data) {
        yield put(setDashboardSubmoduleStudentStatus(response.data));
      }
      yield put(setLoading(false));
    } catch (error) {
      console.error(error);
      yield put(setLoading(false));
    }
  }
  function* teacherDashboardClassChangeSaga(action: any) {
    yield put(setLoading(true));
    yield put(setModuleFilter(null));
    yield put(setAssignmentFilter(null));
    yield put(setModuleOptions([]));
    yield put(setAssignmentOptions([]));
    try {
        const { pageSize, page, status, class_id } = action.payload;
        let response : ResponseType;
        if (status !== undefined && status !== null) {
            response = yield call(
                resourceService.get,
                API_URL + `/api/classes/${class_id}/modules/?status=${status}`,
            );
        } else {
            response = yield call(
                resourceService.get,
                API_URL + `/api/classes/${class_id}/modules/?status=1`,
            );
        }
        if (response.status == 200) {
            yield put(setLoading(false));
            const options = response.data.map((item: any) => ({
              value: item.id,
              label: item.name,
            }));
            yield put(setModuleOptions(options));
            yield put(setModuleFilter(options[0].value));

            if (options.length > 0) {
                  const response: ResponseType = yield call(
              resourceService.get,
              API_URL + `/api/sub_modules_v2/`, { params: { module_id: options[0].value, class_id,active_class_submodules: true  } }

            );
            if (response.status == 200) {
              const options = response.data
              .filter((item: any) => Number(item?.practice_type) === 2)
              .map((item: any) => ({
                value: item.id,
                label: item.name,
              }));
              yield put(setAssignmentOptions(options));
              yield put(setAssignmentFilter(options?.[options.length - 1]?.value ?? null));
            }
          }
        }
    } catch (error) {
        yield put(setLoading(false));
    }
  }
  
  function* teacherDashboardModuleChangeSaga(action: any) {
    const { module_id, class_id } = action.payload;
    yield put(setModuleFilter(module_id));
    yield put(setLoading(true));
    yield put(setAssignmentFilter(null));
    yield put(setAssignmentOptions([]));
    try {
      const response: ResponseType = yield call(resourceService.get, API_URL + `/api/sub_modules_v2/`, { params: { module_id, class_id, active_class_submodules: true } });
      if (response.status == 200) {
        const options = response.data
        .filter((item: any) => Number(item?.practice_type) === 2)
        .map((item: any) => ({
          value: item.id,
          label: item.name,
        }));
        yield put(setAssignmentOptions(options));
        yield put(setAssignmentFilter(options?.[options.length - 1]?.value ?? null));
      }
      yield put(setLoading(false));
    } catch (error) {
      yield put(setLoading(false));
      console.error(error);
    }
  }
export default function* teacherDashboardSaga() {
  yield takeLatest(fetchTeacherDashboardOverview, fetchTeacherDashboardOverviewSaga)
  yield takeLatest(fetchDashboardSubmoduleStudentStatus, fetchDashboardSubmoduleStudentStatusSaga)
  yield takeLatest(teacherDashboardClassChange, teacherDashboardClassChangeSaga)
  yield takeLatest(teacherDashboardModuleChange, teacherDashboardModuleChangeSaga)
}